import { datadogLogs } from '@datadog/browser-logs';
import { formatPinoBrowserLogEvent } from '../formatPinoBrowserLogEvent.js';
const defaults = {
    forwardConsoleLogs: [],
    forwardErrorsToLogs: true,
    trackSessionAcrossSubdomains: true,
    useSecureSessionCookie: true,
    useCrossSiteSessionCookie: true,
    sampleRate: 100
};
let initialized = false;
const createBrowserPinoSend = (options) => {
    const { name } = options;
    // Prevent datadog from being initialized more than once.
    // This can happen in dev when pages are hot-reloaded.
    if (!initialized) {
        datadogLogs.init({
            ...defaults,
            ...options
        });
        initialized = true;
    }
    let logger;
    /* istanbul ignore next */
    if (name) {
        logger = datadogLogs.createLogger(name);
    }
    else {
        logger = datadogLogs.logger;
    }
    /* istanbul ignore next */
    return (level, logEvent) => {
        // extract message, data and bindings from logEvent
        const message = formatPinoBrowserLogEvent(logEvent);
        // Send the log event to Datadog
        switch (level) {
            case 'info':
                logger.info(message.log_entry, message.metadata);
                break;
            case 'warn':
                logger.warn(message.log_entry, message.metadata);
                break;
            case 'error':
                logger.error(message.log_entry, message.metadata);
                break;
            case 'debug':
                logger.debug(message.log_entry, message.metadata);
                break;
            default:
                logger.info(message.log_entry, message.metadata);
        }
        logger.info(message.log_entry, message.metadata);
    };
};
export default createBrowserPinoSend;
//# sourceMappingURL=datadogPino.js.map